import type { ReactNode } from "react";
import { cn } from "@wa/ui";

/**
 * The top of a scrolling page: a display-size title, one sentence saying what
 * the screen is for, and the screen's actions on the right.
 *
 * The sentence is not decoration. It is the only place a page says what happens
 * when you use it, and it carries the one number worth knowing before you read
 * anything else - hence `<b>` inside the copy rather than another stat tile.
 *
 * The title column carries `crm-head-title` rather than the `min-w-0` utility it
 * used to, and the difference is a floor: a utility can only say "may shrink to
 * nothing", and on a head with six controls that is exactly what happened - a
 * 40px heading in a 95px column, four lines tall. The class says the same thing
 * below 901px, where the head wraps anyway, and puts a minimum under it above.
 * The argument in full is beside the rule in `index.css`.
 */
export function PageHead({
  title,
  sub,
  actions,
  className,
}: {
  title: ReactNode;
  sub?: ReactNode;
  actions?: ReactNode;
  className?: string;
}) {
  return (
    <div className={cn("crm-head", className)}>
      <div className="crm-head-title">
        <h1 className="crm-h1">{title}</h1>
        {sub ? <p className="crm-sub">{sub}</p> : null}
      </div>
      {actions ? <div className="crm-head-act">{actions}</div> : null}
    </div>
  );
}
